import React from "react";
import TripScheduleDatePicker from "../components/TripScheduleDatePicker";

const BookSchedule = (props) => <TripScheduleDatePicker {...props} />;

export default BookSchedule;
